exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-submenu [class^=el-icon-]{margin-left:10px !important}.el-menu-item [class^=el-icon-]{margin-left:10px !important}\n", ""]);

// exports
